import { Container } from '@sainsburys-tech/luna-grid'
import { GridWrapper } from '@sainsburys-tech/luna-grid'
import { Key, useEffect } from 'react'
import useCurrentStore from '../../hooks/useCurrentStore'
import Loading from '../Loading'
import { Card } from '@sainsburys-tech/luna-card'
import ErrorMessage from '../ErrorMessage'
import usePage from '../../hooks/usePage'
import { Pagination } from '@sainsburys-tech/luna-pagination'
import { IEnforcementContactsDetails } from '../../types'
import { IPagination } from '../../types/Pagination/IPagination'
import useEnforcementContacts from '../../hooks/useEnforcementContacts'
import EnforcementContactCard from '../Card/Cards/EnforcementContactCard'

const EnforcementContacts = () => {
  const storeCode = useCurrentStore().storeCode
  const pageType = 'EnforcementContactsPage'
  const { page, handlePage } = usePage(pageType)
  let enforcementContactsData: IEnforcementContactsDetails[] | undefined = []
  let pagination: IPagination | undefined

  const [enforcementContactsResource, enforcementContactsLoader] = useEnforcementContacts()

  useEffect(() => {
    enforcementContactsLoader.current(storeCode, page, "enforcementContact")
  }, [enforcementContactsLoader, storeCode, page])

  if (enforcementContactsResource.hasLoaded && !enforcementContactsResource.hasError) {
    const enforcementContactsResponse = enforcementContactsResource.data
    pagination = enforcementContactsResponse?.metadata?.pagination
    enforcementContactsData = enforcementContactsResponse?.results
  }

  if (!enforcementContactsResource.hasLoaded && !enforcementContactsResource.hasError && !enforcementContactsResource.noContent)
    return (
      <Container size="xs">
        <Card id="s-loadingElement" className="ln-u-text-align-center">
          <Loading size="large" />
        </Card>
      </Container>
    )

  if (
    enforcementContactsResource.hasError ||
    !enforcementContactsData ||
    enforcementContactsData?.length <= 0 ||
    enforcementContactsResource.noContent
  )
    return (
      <Container size="xs">
        <ErrorMessage errorMessage="No Reported Enforcement Contacts Were Found" />
      </Container>
    )

  return (
    <>
      <Container className="s-reported-enforcement-contacts-list" size="xs">
        <GridWrapper
          id="s-reported-enforcement-contacts-cards"
          matrix
          gutterSize="sm"
          className="ln-o-grid--gutter-zero@max-mobile"
        >
          {enforcementContactsData.map((enforcementContact: IEnforcementContactsDetails, index: Key) => (
            <EnforcementContactCard key={index} enforcementContact={enforcementContact} />
          ))}
        </GridWrapper>
      </Container>

      {pagination && (
        <Pagination
          id="s-pagination-bar"
          className="ln-u-text-align-center ln-u-margin-ends*3"
          showFirstAndLast
          current={pagination.currentPage + 1}
          total={pagination.totalPages}
          onChange={(page: number, e: any) => {
            e.preventDefault()
            handlePage(pageType, page - 1)
          }}
        />
      )}
    </>
  )
}

export default EnforcementContacts
